import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import vAdminformat from "../adminFormat";
import { Link } from 'react-router-dom';
import config from '../config';
import { headers } from '../token';
import validateError from '../ValidateError';


const server_backend = config.API_URL;

const XeroAuth = () => {
    const client_ID = process.env.REACT_APP_CLIENT_ID;
    const CLIENT_SECRET = process.env.REACT_APP_CLIENT_SECRET;
    const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI;

    const [lastCode, SetLastCode] = useState([]);
    const [authXeroModal, setAutXeroModal] = useState(false);
    const [hasExecuted, setHasExecuted] = useState(false); // State to control execution



    const [formData, setFormData] = useState({
        clientId: '',
        clientSecret: '',
        urlRedirect: '',
        accessToken: '',
        tenantId: '',
        lastlogin: '',
    });

    const [status, setStatus] = useState([]);

    useEffect(() => {
        async function fetchStatus() {
            try {
                const response = await axios.get(`${server_backend}/api/xero/status`, headers);
                console.log({HelloWorld: response.data})
                setStatus(response.data.RES_RESULT);
            } catch (error) {
                console.error('Error fetching Xero status:', error);
            }
        }

        fetchStatus();
    }, []); // It runs once when the component is mounted


    useEffect(() => {
        async function fetchCompany() {
            try {
                const response = await axios.get(`${server_backend}/api/getClientConfig`, headers);
                //console.log({ companyData: response.data });

                SetLastCode(response.data.RES_RESULT);
                //setFormData({ ...formData, urlRedirect: response.data.urlRedirect, lastlogin: response.data.last_login });

            } catch (error) {
                console.error('Error fetching Xero status:', error);
            }
        }

        fetchCompany();
    }, []);

    async function fetchCompany() {
        try {
            const response = await axios.get(`${server_backend}/api/getClientConfig`, headers);

            SetLastCode(response.data.RES_RESULT);
            //console.log(response.data);
            //setFormData({ ...formData, urlRedirect: response.data.urlRedirect, lastlogin: response.data.last_login });

        } catch (error) {
            console.error('Error fetching Xero status:', error);
        }
    }


    async function fetchStatus() {
        try {
            const response = await axios.get(`${server_backend}/api/xero/status`, headers);
            //Console.log(response.data);

            setStatus(response.data.RES_RESULT);
        } catch (error) {
            console.error('Error fetching Xero status:', error);
        }
    }


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const redirectToXeroAuth = () => {
 
        if (!lastCode.clientId || !lastCode.urlRedirect || !lastCode.clientSecret) {
          Swal.fire({
            icon: 'error',
            title: 'Missing Configuration',
            text: 'Please ensure Client ID, URL Redirect, and Client Secret are configured correctly.',
          });
          return;
        }
      
        const scope = 'openid profile email accounting.transactions accounting.settings offline_access';
        
        const xeroAuthUrl = `https://login.xero.com/identity/connect/authorize?response_type=code&client_id=${lastCode.clientId}&redirect_uri=${lastCode.urlRedirect}&scope=${scope}`;
        //Console.log(xero auth url)

        window.location.href = xeroAuthUrl;
      };
      

    const loginXero = async (code) => {
        try {

            const response = await axios.post(`${server_backend}/api/xero/authenticate`, {
                code: code,
                urlRedirect: lastCode.urlRedirect,
            }, headers);

            //Console.log(response.data);


        } catch (error) {
            //Console.log(error);


        } finally {
            fetchStatus()
        }
    };

    const saveData = async () => {
        // Validate if the fields are complete

        if (!formData.clientId || !formData.clientSecret || !formData.urlRedirect) {
            Swal.fire({
                icon: 'error',
                title: 'Missing Parameters',
                text: 'Please complete all required fields before saving.',
                confirmButtonText: 'Ok'
            });
            return; // Get out of the function if data are missing

        }
    
        Swal.fire({
            icon: 'warning',
            title: 'Alert',
            text: "Are you sure you want to save this information?",
            showCancelButton: true,
            confirmButtonText: 'Accept',
            cancelButtonText: "Cancel"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.post(`${server_backend}/api/xero/saveCompanyData`, {
                        clientId: formData.clientId,
                        clientSecret: formData.clientSecret,
                        urlRedirect: formData.urlRedirect,
                    }, headers);
    
                    if (response.data.RES_CODE === '00') {
                        Swal.fire({
                            icon: 'success',
                            title: 'Saved Successfully',
                            showConfirmButton: false,
                            timer: 2000
                        });
                    }
    
                } catch (error) {
                    //Console.log(error);

                    validateError(error);
                } finally {
                    setAutXeroModal(false);
                    fetchStatus();
                    fetchCompany();
                }
            }
        });
    };
    


    useEffect(() => {
        const code = new URLSearchParams(window.location.search).get('code');
        if (code && lastCode.clientId) {
            loginXero(code);
        }
    }, [lastCode]);

    const getTenantId = async () => {
        try {

            const response = await axios.post('http://localhost:5000/api/xero/tenant', { accessToken: formData.accessToken });
            setFormData({ ...formData, tenantId: response.data.tenantId });
            localStorage.setItem('xeroTenantId', response.data.tenantId);

        } catch (error) {

        }
    };

    const createInvoiceXero = async () => {
        try {


            const invoiceData = {
                "type": "ACCREC",
                "contact": {
                    "contactID": "fe86b2ae-5c58-49b7-a5c6-fa7c8b8130c3",
                    "name": "Ronalsd"
                },
                "date": "\/Date(1518685950940+0000)\/",
                "dueDate": "\/Date(1518685950940+0000)\/",
                "dateString": "2025-05-27T00:00:00",
                "dueDateString": "2025-06-06T00:00:00",
                "lineAmountTypes": "Exclusive",
                "lineItems": [
                    {
                        "description": "Consulting services as agreed (20% off standard rate)",
                        "quantity": "10",
                        "unitAmount": "100.00",
                        "accountCode": "200",
                        "discountRate": "20"
                    }
                ]
            };

            ;

            // Change the URL to point to your node.js server

            const url = 'http://localhost:5000/api/xero/invoice'; // Change according to the address of your server


            // Sending Post request to your server

            await axios.post(url, { tenantId: formData.tenantId, invoiceData });


        } catch (error) {
            //Console.log(error);


        }
    };


    return (
        <div className="page-content" data-simplebar-track="secondary" data-simplebar="init" style={{ overflow: "auto" }}>

            <div>
                <div className="card-header">
                    <div className="d-flex justify-content-end">
                        <div className="flex-grow-1">
                            <center><h5>Xero server</h5></center>
                        </div>
                    </div>
                    <div className="flex-grow-1 d-flex align-items-center justify-content-between">
                        {/* Job Number text */}
                        <h5 className="mb-0">
                            Last Login: <Link>{vAdminformat.FormatDate(formData.lastlogin)}</Link>
                        </h5>

                        {/* Buttons aligned to the right */}
                        <div className="hstack gap-2">

                            {/* Save change button */}
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => {
                                    setAutXeroModal(true);
                                }}
                            >
                                <i class="ri-settings-3-line"></i>
                            </button>

                            <button
                                type="button"
                                className="btn btn-success"
                                onClick={redirectToXeroAuth}
                            >
                                Start Authentication
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-12 card card-body" style={{ minHeight: "90vh" }}>

                    <div className="col-lg-12">
                        <div className="card pricing-box ribbon-box ribbon-fill text-center">
                            <div className="ribbon ribbon-primary">Xero</div>
                            <div className="row g-0">
                                <div className="col-12">
                                    <div className="card-body h-100">
                                        <div>

                                            <p className="text-muted">Your Client ID and Client Secret is used to authenticate your application with Xero. Do not share it with anyone.</p>
                                        </div>

                                        <div className="row ">
                                            <div className="col-12">
                                                <div>
                                                    {/* <div className="card-header bg-light">
                                                        <h5 className="fs-15 mb-0">Authentication Status:</h5>
                                                    </div> */}
                                                    <div className="card-body pb-0">
                                                        <ul className="list-unstyled vstack gap-3 mb-0">
                                                            <li className="d-flex justify-content-between align-items-center">
                                                                <span>Status:</span>
                                                                <i
                                                                    style={{ fontSize: "28px" }}
                                                                    className={`fa ${status?.authStatus?.step === 'success' ? 'ri-checkbox-circle-line text-success' : null}`}
                                                                ></i>
                                                                {status?.authStatus?.step === 'error' ? (
                                                                    <label className="text-danger">{status.authStatus.message}</label>
                                                                ) : null}
                                                            </li>
                                                            {/*  <li className="d-flex justify-content-between align-items-center">
                                                                <span>Access Token:</span>
                                                                <i
                                                                    style={{ fontSize: "28px" }}
                                                                    className={`fa ${status?.accessToken?.step === 'success' ? 'ri-checkbox-circle-line text-success' : null}`}
                                                                ></i>
                                                                {status?.accessToken?.step === 'error' ? (
                                                                    <label className="text-danger">{status.accessToken.message}</label>
                                                                ) : null}
                                                            </li> */}
                                                            <li className="d-flex justify-content-between align-items-center">
                                                                <span>Client ID:</span>
                                                                <i
                                                                    style={{ fontSize: "28px" }}
                                                                    className={`fa ${status?.ClientStatus?.step === 'success' ? 'ri-checkbox-circle-line text-success' : null}`}
                                                                ></i>
                                                                {status?.ClientStatus?.step === 'error' ? (
                                                                    <label className="text-danger">{status.ClientStatus.message}</label>
                                                                ) : null}
                                                            </li>
                                                            <li className="d-flex justify-content-between align-items-center">
                                                                <span>Client Secret:</span>
                                                                <i
                                                                    style={{ fontSize: "28px" }}
                                                                    className={`fa ${status?.clientSecret?.step === 'success' ? 'ri-checkbox-circle-line text-success' : null}`}
                                                                ></i>
                                                                {status?.clientSecret?.step === 'error' ? (
                                                                    <label className="text-danger">{status.clientSecret.message}</label>
                                                                ) : null}
                                                            </li>
                                                            <li className="d-flex justify-content-between align-items-center">
                                                                <span>Company or application URL:</span>
                                                                <i
                                                                    style={{ fontSize: "28px" }}
                                                                    className={`fa ${status?.UrlRedirect?.step === 'success' ? 'ri-checkbox-circle-line text-success' : null}`}
                                                                ></i>
                                                                {status?.UrlRedirect?.step === 'error' ? (
                                                                    <label className="text-danger">{status.UrlRedirect.message}</label>
                                                                ) : null}
                                                            </li>
                                                        </ul>
                                                    </div>

                                                </div>
                                            </div>


                                        </div>


                                    </div>
                                </div>
                                {/* end col */}

                                {/* end col */}
                            </div>
                            {/* end row */}
                        </div>
                    </div>

                </div>
            </div>
            <div
                className={`modal fade ${authXeroModal ? "show" : ""}`}
                style={{ display: authXeroModal ? "block" : "none", backgroundColor: "#0000007a" }}
                tabIndex="-1"
            >
                <div className="modal-dialog modal-dialog-centered modal-sm">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-danger" id="myExtraLargeModalLabel">
                                Important: Client ID and Client Secret are access credentials. Do not share them.
                            </h5>
                            <Link className="btn-close" onClick={() => setAutXeroModal(false)} aria-label="Close"></Link>
                        </div>
                        <div className="modal-body">
                            <div className="row g-4 p-3">
                                <div className="col-6">
                                    <label className="form-label">Client ID</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="clientId"
                                        value={formData.clientId}
                                        onChange={handleChange}
                                        autoComplete="off"
                                    />
                                </div>
                                <div className="col-6">
                                    <label className="form-label">Client Secret</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="clientSecret"
                                        value={formData.clientSecret}
                                        onChange={handleChange}
                                        autoComplete="off"

                                    />
                                </div>
                                <div className="col-12 mt-2">
                                    <label className="form-label">Company or application URL</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="urlRedirect"
                                        value={formData.urlRedirect}
                                        onChange={handleChange}
                                        autoComplete="off"

                                    />
                                </div>
                            </div>

                            {/* Buttons at the foot */}
                            <div className="d-flex justify-content-end mt-4">
                                <Link type="button" className="btn btn-danger me-2" onClick={() => setAutXeroModal(false)}>
                                    Discard
                                </Link>
                                <button
                                    type="button"
                                    onClick={saveData}
                                    className="btn btn-secondary waves-effect waves-light"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default XeroAuth;
